import { INACTIVE_STATUSES } from "@/shared/domains";
import type { Subscription } from "@/shared/domains";

export const isInactiveSubscription = (status: Subscription["status"]) =>
  INACTIVE_STATUSES.some((inactiveStatus) => inactiveStatus === status);
